import Image1 from "../../assets/woman1.png";
import Image2 from "../../assets/man.png";
import Image3 from "../../assets/woman2.png";

export const Data = [
    {
        id: 1,
        image: Image2,
        title: "Ali Boussaidene",
        description: "بارك الله فيك استاذ على هذا الدرس القيم.🤍 ",
    },
    {
        id: 2,
        image: Image2,
        title: "abdelaziz elkharraz",
        description: "أحسنت أحسن الله إليك يا استاذ 🤍",
    },
    {
        id: 3,
        image: Image1,
        title: "joumana",
        description: "شرحك ممتاز يا مستر جزاك الله كل خير 🌹",
    },
    {
        id: 4,
        image: Image2,
        title: "Saeed Elrewieny",
        description: "اول مره اسمع حضرتك شرحك ممتاز ممتاز ممتاز برجاء لاتتركنا فى هذا الطريق  لك اجر أعلى أجر فى الدنيا انشاء الله من موزعع الأرزاق",
    },
    {
        id:5,
        image: Image1,
        title: "joumana",
        description: "شرحك ممتاز يا مستر جزاك الله كل خير 🌹",
    },
];